import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { ListItem, Button } from '@rneui/themed';
import Animated, { withTiming, useAnimatedStyle, useSharedValue, } from 'react-native-reanimated';
import { Text } from '@rneui/themed';
import { useUserUUID } from '@annunciate/core';
import { FAIcon, View, useTheme } from '@annunciate/ui';
import { CommentForm } from './CommentForm';
import { Comments } from './Comments';
import { Avatar } from './Avatar';
import { getTimeSinceComment } from '../utils';
import { useCommentDeleteMutation } from '../hooks';
export const Comment = ({ comment, endpoint, discussionId, queryKey, depth, maxDepth, }) => {
    const canReply = depth < maxDepth;
    const { colors } = useTheme();
    const uuid = useUserUUID();
    const { mutateAsync: remove } = useCommentDeleteMutation(endpoint, queryKey);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isReplyOpen, setIsReplyOpen] = useState(false);
    const replyCount = comment.childrenCount;
    const rotation = useSharedValue(0);
    useEffect(() => {
        rotation.value = withTiming(isExpanded ? -180 : 0, {
            duration: 250,
        });
    }, [isExpanded]);
    const repliesHandleStyle = useAnimatedStyle(() => {
        return {
            marginRight: 10,
            transform: [{
                    rotate: `${rotation.value}deg`,
                }],
        };
    });
    return (React.createElement(ListItem.Accordion, { content: React.createElement(ListItem, { style: { width: '100%' } },
            React.createElement(Avatar, { user: comment.user }),
            React.createElement(ListItem.Content, null,
                React.createElement(ListItem.Title, { style: { width: '100%' } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            width: '100%',
                            alignItems: 'center',
                        } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                marginRight: 'auto',
                                alignItems: 'center',
                            } },
                            React.createElement(Text, { h2: true, bold: true, style: styles.name }, comment.user.name),
                            React.createElement(Text, { style: [styles.textSpacer, { fontSize: 15 }] }, getTimeSinceComment(new Date(comment.createdAt))),
                            comment.createdAt !== comment.updatedAt && (React.createElement(Text, { style: styles.textSpacer }, "(edited)"))),
                        uuid === comment.user.id && (React.createElement(Button, { type: "clear", onPress: async () => {
                                await remove({ id: comment.id });
                            } },
                            React.createElement(FAIcon, { name: "trash" }))))),
                React.createElement(Text, null, comment.body),
                canReply && (React.createElement(Button, { type: "clear", icon: React.createElement(FAIcon, { name: "reply", style: { marginRight: 5 } }), style: { marginTop: 10 }, buttonStyle: styles.actionButton, onPress: () => setIsReplyOpen(true) }, "Reply")),
                isReplyOpen && (React.createElement(CommentForm, { discussionId: discussionId, endpoint: endpoint, parentId: comment.id, onClose: () => setIsReplyOpen(false), onSubmitSuccess: () => setIsExpanded(true), queryKey: queryKey })),
                replyCount > 0 && (React.createElement(Button, { type: "clear", color: "secondary", icon: (React.createElement(Animated.View, { style: repliesHandleStyle },
                        React.createElement(FAIcon, { name: "chevron-down", style: { color: colors.accent } }))), buttonStyle: styles.actionButton, onPress: () => setIsExpanded(!isExpanded) },
                    React.createElement(Text, { bold: true, style: { color: colors.accent } },
                        replyCount,
                        " ",
                        replyCount > 1 ? `Replies` : `Reply`))))), noIcon: true, isExpanded: isExpanded && replyCount > 0 },
        React.createElement(View, { style: { marginLeft: 50 } }, isExpanded && (React.createElement(Comments, { discussionId: discussionId, parentId: comment.id, endpoint: endpoint, depth: depth + 1, maxDepth: maxDepth })))));
};
const styles = StyleSheet.create({
    name: {
        marginRight: 10,
    },
    textSpacer: {
        marginLeft: 5,
    },
    actionButton: {
        paddingLeft: 0,
    },
});
//# sourceMappingURL=Comment.js.map